/*
 * Copyright (C) 2020 Reciprocity, Inc - All Rights Reserved
 * Unauthorized use, copying, distribution, displaying, or public performance
 * of this file, via any medium, is strictly prohibited. All information
 * contained herein is proprietary and confidential and may not be shared
 * with any third party without the express written consent of Reciprocity, Inc.
 */

import Axios, { AxiosError, AxiosResponse } from 'axios';

import { constructLoginRoute } from '@/router/utils';

export const configureAxios = (axios: typeof Axios) => {
  axios.interceptors.response.use(responseInterceptor, responseErrorInterceptor);
};

const responseInterceptor = (response: AxiosResponse) => {
  return response;
};

const responseErrorInterceptor = (error: AxiosError) => {
  const unauthorized: boolean = !!error.response && error.response.status == 401;

  if (unauthorized) {
    const fullPath = window.location.pathname + window.location.search;
    window.location.href = constructLoginRoute(fullPath);
  }

  return Promise.reject(error);
};
